"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSourceData = loadSourceData;
var _axios = _interopRequireDefault(require("./axios"));
var axios = new _axios.default({
  pure: true
});

// 获取标签keys
function loadSourceData(_ref) {
  var url = _ref.url,
    method = _ref.method,
    params = _ref.params,
    data = _ref.data,
    headers = _ref.headers;
  return axios({
    url: url,
    method: method,
    params: params,
    data: data,
    headers: headers
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/dform.js
// module id = TdXZ
// module chunks = 19